import { wrapWithI18nProvider } from "../i18n/wrapWithI18nProvider"

const PageElementWrapper = ({element, props}) => {
  return wrapWithI18nProvider({ element, props })
}

export default PageElementWrapper
